import Barcode from 'apps/builder/assets/icons/barcode.svg'
import Calculation from 'apps/builder/assets/icons/calculation.svg'
import Checkbox from 'apps/builder/assets/icons/checkbox.svg'
import Date from 'apps/builder/assets/icons/date.svg'
import Drawing from 'apps/builder/assets/icons/drawing.svg'
import GPS from 'apps/builder/assets/icons/gps.svg'
import LongText from 'apps/builder/assets/icons/long-text.svg'
import Mirror from 'apps/builder/assets/icons/mirror.svg'
import MultiChoice from 'apps/builder/assets/icons/multiple-choice.svg'
import Number from 'apps/builder/assets/icons/number.svg'
import Payment from 'apps/builder/assets/icons/payment.svg'
import Photo from 'apps/builder/assets/icons/photo.svg'
import ShortText from 'apps/builder/assets/icons/short-text.svg'
import Signature from 'apps/builder/assets/icons/signature.svg'
import StaticImage from 'apps/builder/assets/icons/static-image.svg'
import StaticText from 'apps/builder/assets/icons/static-text.svg'
import Sum from 'apps/builder/assets/icons/sum.svg'
import SingleChoice from 'apps/builder/assets/icons/single-choice.svg'
import Time from 'apps/builder/assets/icons/time.svg'
import WebLink from 'apps/builder/assets/icons/web-link.svg'
import Rating from 'apps/builder/assets/icons/rating.svg'
import Slider from 'apps/builder/assets/icons/slider.svg'
import SingleChoiceBoxes from 'apps/builder/assets/icons/singlechoiceboxes.svg'
import MultipleChoiceButtons from 'apps/builder/assets/icons/multiplechoicebuttons.svg'
import PassFail from 'apps/builder/assets/icons/passfail.svg'
import Increment from 'apps/builder/assets/icons/increment.svg'
import Video from 'apps/builder/assets/icons/video.svg'
import Attachment from 'apps/builder/assets/icons/attachment.svg'
import Dropdown from 'apps/builder/assets/icons/dropdown.svg'

const fieldIcons = {
  Barcode: Barcode,
  Calculation: Calculation,
  Checkbox: Checkbox,
  Date: Date,
  Drawing: Drawing,
  'Single Choice': SingleChoice,
  GPS: GPS,
  'Long Text': LongText,
  Mirror: Mirror,
  'Multiple Choice': MultiChoice,
  'Pass/Fail': PassFail,
  Number: Number,
  Payment: Payment,
  Photo: Photo,
  Text: ShortText,
  Signature: Signature,
  'Static Image': StaticImage,
  'Static Text': StaticText,
  Sum: Calculation,
  Time: Time,
  Link: WebLink,
  Rating: Rating,
  Slider,
  'Single Choice Boxes': SingleChoiceBoxes,
  'Multiple Choice Buttons': MultipleChoiceButtons,
  Increment,
  Video: Video,
  Attachment: Attachment,
  Dropdown,
}

export const FieldIcon = ({ type = '', additionalClasses }) => {
  const IconType = fieldIcons[type] || ShortText
  const typeClass = `${type}`.toLowerCase().replace(/\W/g, '-')
  return (
    <span className={`field--icon field--type-${typeClass} ${additionalClasses}`}>
      <IconType />
    </span>
  )
}
